import PropTypes from 'prop-types';
import { withTranslation, Trans } from 'react-i18next';
import { Button, Input, InputOTP, IconModal, Passcode } from '@airtm/airtm-ui';
import { OTP_CODE_LENGTH } from '@constants';

const CodeModal = function ({
  errorMessage = null,
  onChange,
  onClickBack,
  onHide,
  onSubmitCode,
  show,
  otpCode,
  t,
  phone,
}) {
  return (
    <IconModal modalClose={onHide} show={show}>
      <IconModal.Body
        className="pt-0"
        icon={<Passcode />}
        title={t('SETTINGS:PHONE_VERIFICATION_TITLE')}
      >
        <p className="mb-4">
          <Trans
            i18nKey="SETTINGS:PHONE_EXPLANATION_SENT"
            values={{
              phone: phone?.substring(phone.length - 4) || '',
            }}
          />
        </p>
        <div className="d-flex flex-column align-items-center justify-content-center">
          <InputOTP
            autoComplete="off"
            autoFocus
            id="otp-code"
            name="otp-code"
            label={t('SETTINGS:PHONE_VERIFICATION_CODE')}
            onChange={(value) => onChange('otpCode', value)}
            placeholder={t('SETTINGS:CODE_PLACEHOLDER')}
            size="lg"
            type="text"
            value={otpCode}
            maxLength={OTP_CODE_LENGTH}
            invalid={errorMessage}
          />
          {errorMessage && <Input.HelperText invalid>{errorMessage}</Input.HelperText>}
        </div>
      </IconModal.Body>
      <IconModal.Actions>
        <Button onClick={onClickBack} variant="secondary" data-testid="back-code-verification-su">
          {t('SETTINGS:GO_BACK')}
        </Button>
        <Button
          variant="primary"
          data-testid="submit-verification-code-su"
          onClick={onSubmitCode}
          disabled={!(otpCode && otpCode.length === 6) || errorMessage}
        >
          {t('SETTINGS:SUBMIT_CODE')}
        </Button>
      </IconModal.Actions>
    </IconModal>
  );
};
CodeModal.propTypes = {
  errorMessage: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClickBack: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  onSubmitCode: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  otpCode: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};
export default withTranslation(['SETTINGS'])(CodeModal);
